import React from 'react'
import { Form, Button } from 'antd'
import './index.less'

const layout = {
  labelCol: { span: 2 },
  wrapperCol: { span: 10 },
}

interface ItemProps {
  data?: SwaggerDTO.地址信息
  /**编辑 */
  editHandle?: Function
  /**删除 */
  deleteHandle?: Function
  /**设置默认地址 */
  defaultHandle?: Function
}

export default function Item({
  data,
  editHandle,
  deleteHandle,
  defaultHandle,
}: ItemProps) {
  return (
    <div className="address-item">
      {!!data?.defaultAddressTag && (
        <div className="address-default">默认地址</div>
      )}
      <Form {...layout} className="address-item-form">
        <Form.Item label="收货人">{data?.addressee}</Form.Item>
        <Form.Item label="所在地区">
          {data?.provinceName}
          {data?.cityName}
          {data?.areaName}
        </Form.Item>
        <Form.Item label="详细地址">{data?.address}</Form.Item>
        <Form.Item label="联系电话">{data?.linkMobile}</Form.Item>
      </Form>
      <div className="address-options">
        {!data?.defaultAddressTag && (
          <Button
            type="link"
            size="small"
            onClick={() => defaultHandle?.(data)}
          >
            设为默认地址
          </Button>
        )}
        <Button type="link" size="small" onClick={() => editHandle?.(data)}>
          编辑
        </Button>
        <Button type="link" size="small" onClick={() => deleteHandle?.(data)}>
          删除
        </Button>
      </div>
    </div>
  )
}
